<template>
	<div class="modal fade" id="myModal2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-body modal-body-sub_agile dir-rtl" style="padding:0 !important">
					<button type="button" class="close" data-dismiss="modal" style="display: none;"
						id="signModalCloseBTN">&times;</button>
					<div class="col-md-12 container">
						<h3 class="agileinfo_sign mb-2" style="text-align:center">به خانواده راداَپ خوش آمدید</h3>
						<form autocomplete="off" >
						<div class="mb-3">
						<label>نام: * </label>
							<input type="text" class="form-control" placeholder="مثلا محسن" v-model="information.name">
						</div>
						<div class="mb-3">
						<label>نام خانوادگی : *</label>
							<input type="text" class="form-control" placeholder="مثلا علیزاده" v-model="information.family">
						</div>
						<div class="mb-3 d-none">
							<input type="text" class="form-control" placeholder="موبایل"  disabled :value="suserMobile">
						</div>
						<div class="mb-3">
							<label>رمز عبور : *<small> (حداقل 4 کاراکتر وارد نمایید)</small></label>
							<div class="form-group form-group-lg search-input mb-3" style="margin-bottom: 0px;width: 100%;">
								<label style="z-index: 9999;">
									<i class="fa fa-eye" aria-hidden="true" style="cursor: pointer;" @click="passwordTextFunc"></i>
								</label>
								<input class="form-control dir-rtl password pr-3" :type="passwordTextFlag" v-model="information.password">
							</div>
						</div>
						<div class="mb-3">
							<label>تکرار رمز عبور : *</label>
							<div class="form-group form-group-lg search-input mb-3" style="margin-bottom: 0px;width: 100%;">
								<label style="z-index: 9999;">
									<i class="fa fa-eye" aria-hidden="true" style="cursor: pointer;" @click="passwordTextFunc"></i>
								</label>
								<input class="form-control dir-rtl password pr-3 repassword" :type="passwordTextFlag" v-model="information.repassword">
							</div>
						</div>
					</form>
						<div class="styled-input">
							<span style="font-size: small;">
								<input type="checkbox" id="inforamtionAccept"  checked>
								<a href="https://radap.ir/Rulls" target="_blank" class="text-link px-1">قوانین و مقررات</a> راداَپ را میپذیرم.
							</span>
						</div>
						<span style="color:red;display:block;margin-bottom:10px">{{ errorMessage }}</span>
						<button type="button" class="btn btn-primary my-3 w-100" @click="submitInformation" v-if="finallFlag">تکمیل ثبت نام</button>
						<button v-if="!finallFlag" class="btn btn-primary w-100 my-3" disabled>
							<div class="spinner-border text-light" role="status" style="vertical-align: middle;margin-left: 10px;width: 20px;height: 20px;">
									<span class="visually-hidden">Loading...</span>
							</div>
							لطفا شکیبا باشید
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<button type="button" id="signModalBTN" data-bs-toggle="modal" data-bs-target="#myModal2" style="display:none"></button>
</template>

<script setup>
import { reactive, ref, defineProps, defineEmits,watch } from 'vue'
import { convertToEnglish, convertToPersian } from "@/composables/digits.js";

import { useRoute } from 'vue-router';
import axios from 'axios';
import { alertBox } from '@/composables/silverBox';
const props = defineProps(['suserMobile']);
// const emits = defineEmits(['suserMobile']);
let route = useRoute()
let reagentCode = ref();
let passwordTextFlag = ref('password');
let finallFlag = ref(true)

let information = reactive({
	id: '',
	name: '',
	family: '',
	mobile: '',
	password: '',
	repassword: '',
	wallet: '',
	score: '',
	location: '',
	location2: '',
	location3: '',
	born: '',
	nid: '',
	sheba: '',
	gender: '',
	email: '',
	token: ''
})

watch(information,() => {
	if(information.password.length >= 4){
		document.querySelector('.password').classList.add('border-green')
	}else{
		document.querySelector('.password').classList.remove('border-green')
	}
	if(information.repassword == information.password && information.password.length >= 4){
		document.querySelector('.repassword').classList.add('border-green')
	}else{
		document.querySelector('.repassword').classList.remove('border-green')
	}
	information.password = convertToPersian(information.password)
	information.repassword = convertToPersian(information.repassword)
})
let errorMessage = ref();
function submitInformation() {
	finallFlag.value = false
	information.password = convertToEnglish(information.password)
	information.repassword = convertToEnglish(information.repassword)
	if (document.getElementById('inforamtionAccept').checked == false) {
		alertBox("لطفا ابتدا قوانین و مقررات سایت را مطالعه و سپس تایید نمایید")
		finallFlag.value = true
	} else if (information.name && information.family && information.password && information.repassword) {
		if (information.password.length >= 4) {
			if (information.password == information.repassword) {
				if(information.name.length >= 2){
					if(information.family.length >= 2){
						information.mobile = props.suserMobile;
						errorMessage.value = '';
						addUser()
					}else{
						errorMessage.value = 'تعداد مجاز نام خانوادگی حداقل 2 کاراکتر است'
						finallFlag.value = true
					}
				}else{
					errorMessage.value = 'تعداد مجاز نام حداقل 2 کاراکتر است'
					finallFlag.value = true
				}
			} else {
				errorMessage.value = 'رمز عبور و تکرار آن یکسان نیست'
				finallFlag.value = true
			}
		} else {
			errorMessage.value = 'تعداد مجاز رمز عبور حداقل 4 کاراکتر است'
			finallFlag.value = true
		}
	} else {
		errorMessage.value = 'لطفا تمام موارد را تکمیل کنید'
		finallFlag.value = true
	}
}
function addUser() {
	information.mobile = convertToEnglish(information.mobile)
	reagentCode.value = route.params.id;
	if (reagentCode.value === undefined || route.name != 'Invite') {
		reagentCode.value = 'noCode';
	}

	const formData = new FormData();
    formData.append('name', information.name);
	formData.append('family', information.family);
	formData.append('mobile', information.mobile);
	formData.append('password', information.password);
	formData.append('regent', reagentCode.value);
	axios.post('https://radap.ir/Backend/api/section/follow/addUser_new.php',formData)
		.then((response) => {
			if (response.data == 'exist') {
				errorMessage.value = 'شما قبلا ثبت نام کرده اید';
			} else {
				let token = response.data
				localStorage.setItem('token',token)
				alertBox('ثبت نام شما با موفقیت انجام شد','success')
				setTimeout(()=>window.location.href = 'https://radap.ir',1000)
			}
		})
}

function passwordTextFunc(){
	if(passwordTextFlag.value == 'password'){
		passwordTextFlag.value = 'text'
	}else{
		passwordTextFlag.value = 'password'
	}
}
</script>

<style scoped>
input {
	opacity: .8;
	letter-spacing: 0 !important;
}
.border-green{
	border-color: green !important;
}
</style>